export enum TypeSignatureEnum {
    ELETRONICA = 'Eletrônica',
    DIGITAL = 'Digital',
}
export enum TypeSignatureCharEnum {
    eletronic = 'E',
    digital = 'P',
}
